import React, { useState, useEffect } from 'react';
import './LoadingScreen.css';

const PaintbrushLoadingScreen = ({ dataFetched, onLoadingComplete, isActiveInstance, instanceLifeMins, handleClearInstance }) => {
  const [finalAnimation, setFinalAnimation] = useState(false);
  const [showDataGrid, setShowDataGrid] = useState(false);
  const [dots, setDots] = useState("");

  useEffect(() => {
    let dotTimeout;
    let dotInterval;

    if (!dataFetched && isActiveInstance) {
      dotTimeout = setTimeout(() => {
        dotInterval = setInterval(() => {
          setDots((prevDots) => (prevDots.length < 3 ? prevDots + "." : ""));
        }, 500);
      }, 4000); // 4-second delay before dots start
    }

    if (dataFetched && isActiveInstance) {
      clearInterval(dotInterval);
      clearTimeout(dotTimeout);

      const strokeToDone = setTimeout(() => setDots(""), 0);
      const heartbeatDelay = setTimeout(() => {
        setFinalAnimation(true);
        const transitionDelay = setTimeout(() => {
          setShowDataGrid(true);
          onLoadingComplete();
        }, 1000);

        return () => clearTimeout(transitionDelay);
      }, 1000);

      return () => {
        clearTimeout(strokeToDone);
        clearTimeout(heartbeatDelay);
      };
    }

    if (!isActiveInstance) {
      setDots("");
      setFinalAnimation(false);
      setShowDataGrid(false);
    }

    return () => {
      clearInterval(dotInterval);
      clearTimeout(dotTimeout);
    };
  }, [dataFetched, onLoadingComplete, isActiveInstance]);

  if (!isActiveInstance) {
    return (
      <div className="conflict-container">
        <h2 className="conflict-message">
          Another instance of the admin system was opened {instanceLifeMins} minutes ago.
          <br /><br />
          Please close this window and return to the active one.
          <br /><br />
          Pressing the button below may cause issues, or simply not work, if another instance remains open.
        </h2>
        <button className="reset-button" onClick={handleClearInstance}>
          Clear Instance and Reload
        </button>
      </div>
    );
  }

  if (showDataGrid) {
    return null; // This will make the loading screen disappear, allowing the data grid to show
  }

  const renderLetters = (text) => {
    const letters = text.split("");
    return letters.map((letter, index) => (
      <div
        key={index}
        className="stroke"
        style={{ animationDelay: `${index * 0.5}s` }}
      >
        {letter}
      </div>
    ));
  };

  const textToShow = dataFetched ? "DONE" : "LOADING";

  return (
    <div className="loading-container">
      <div className={`paintbrush-container ${finalAnimation ? 'heartbeat' : ''}`}>
        {renderLetters(textToShow)}
        {!finalAnimation && <span className="dots">{dots}</span>}
      </div>
      <p className="loading-text" style={{ opacity: finalAnimation ? 0 : 1 }}>Please wait a moment.</p>
    </div>
  );
};

export default PaintbrushLoadingScreen;
